export default __webpack_public_path__ + "static/media/reebok_stimuli.c415de58.mp4";